/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Link from 'next/link';
import _ from 'lodash';

// Components
import { Text } from '@components';

// Containers
import { VideoThumb } from '@containers';

// Themes
import { main as theme } from '@themes';

// Styles
import { styles } from './ListVideos.styles';

const Wrapper = styled.div`
  ${styles}
`;

const ListVideos = ({ data }) => {
  return (
    <Wrapper>
      <header />
      {data && (
        <>
          <div className="search-video__list">
            {data.data.map((item, index) => {
              const keythumb = `${item.video_type}-${index}`;

              return <VideoItem item={item} key={keythumb} />;
            })}
          </div>
        </>
      )}
    </Wrapper>
  );
};

const VideoItem = ({ item }) => {
  return item && (
    <div className="search-video__item">
      <div className="search-video__thumb">
        <Link href="/curso/aula/[aula]" as={item.url}>

          <VideoThumb
            alt={item.title}
            img={_.get(
              item,
              'thumbnails[3].link',
              'https://i.vimeocdn.com//video//883665447_640x360.jpg?r=pad'
            )}
            radius="6"
            time={item?.progress?.toString() || '0'}
            // source="cloudinary"
            source="external"
            iconSize="30px"
          />

        </Link>
      </div>
      <div className="search-video__title">
        <Text
          as="h3"
          dsize="1.6rem"
          size="1.6rem"
          weight="bold"
          dheight="2rem"
          color={theme.colorSystem.white}
        >
          {item.title}
        </Text>
      </div>
      <div className="search-video__subtitle">
        {/* <Text
          as="p"
          dsize="1.2rem"
          size="1.2rem"
          dheight="1.6rem"
          transform="uppercase"
          color={theme.colorPallete.base[400]}
        >

          {`${item?.header?.author || item?.title}`}
        </Text> */}
      </div>
    </div>
  );
};
export { VideoItem };

ListVideos.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

ListVideos.defaultProps = {
  data: [],
};

export default ListVideos;
export { ListVideos };
